<template>
  <b-row class="mt-n1">
    <b-col>
      <b-card no-body>
        <b-row no-gutters class="align-items-center bg-light">
          <b-col sm="12" v-if="busInfo">
            <BusInfo :result="result"/>
          </b-col>
          <b-col sm="12" v-else-if="flightInfo">
            <FlightInfo :result="result"/>
          </b-col>
          <b-col sm="12" v-else>
            <CarInfo :params="params"/>
          </b-col>
          <!-- <b-col sm="4">
            <div class="text-center selectedPdf py-3 shadow mr-0 mr-sm-n2 rounded">
              <p class="mb-0">pret de la</p>
              <h2 style="text-shadow: 1px 1px 1px #000;">{{ getFullPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{ params.currency }}</h2>
            </div>
          </b-col> -->
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { getFullPrice } from 'b2b-common/utils/hotel'
import BusInfo from './bus_info'
import FlightInfo from './flight_info'
import CarInfo from './car_info'

export default {
  name: 'DepartureInfo',
  props: ['params', 'result', 'displayedMeal', 'fees'],
  components: { BusInfo, FlightInfo, CarInfo },
  data () {
    return {
      busInfo: null,
      flightInfo: null
    }
  },
  created () {
    if (this.result.packages) {
      this.busInfo = this.result.packages[0].busInfo
      this.flightInfo = this.result.packages[0].flightInfo
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    getFullPrice
  }
}
</script>
